import React from 'react';
interface IMenuContext {
  leftMenuOpen: boolean;
  rightMenuOpen: boolean;
  toggleOpen: IToggleOpen;
}
export type IToggleOpen = (
  anchor: 'left' | 'right',
  value: boolean,
  callback?: () => void
) => void;
export const MenuContext = React.createContext<IMenuContext>({
  leftMenuOpen: false,
  rightMenuOpen: false,
  toggleOpen: (anchor, value) => {},
});
